var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.isChkLoading ? '' : 'full-background',staticStyle:{"position":"relative","z-index":"1","height":"100%"}},[_c('router-view'),_c('upload-progress')],1)}
var staticRenderFns = []

export { render, staticRenderFns }